import { render, staticRenderFns } from "./TissueSubmissionForm.vue?vue&type=template&id=d06de504"
import script from "./TissueSubmissionForm.vue?vue&type=script&lang=js"
export * from "./TissueSubmissionForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports